"use client";
import { useEffect, useRef } from "react";
import Lottie from "lottie-react";

import competiveAnalysisVideo from "public/assets/homePage/competitiveAnalysis/competitive-analysis.json";

const LottieVideo = () => {
  const containerRef = useRef(null);
  const lottieRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        lottieRef.current?.goToAndPlay(0, true);
        observer.unobserve(entry.target);
      },
      { threshold: 0.4 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef}>
      <Lottie
        lottieRef={lottieRef}
        animationData={competiveAnalysisVideo}
        loop={false}
        autoplay={false}
      />
    </div>
  );
};

export default LottieVideo;
